import {useStripe, useElements, CardElement} from '@stripe/react-stripe-js'
import axios from 'axios'
import React, {useEffect, useState} from 'react'
import {Button, Modal} from 'react-bootstrap'
import {useDispatch, useSelector} from 'react-redux'
import {toast} from 'react-toastify'
import {GetCardList} from '../../../Redux/AdminPanel/PurchaseCreditSlice'
import {startLoadding, stopLoading} from '../../../Redux/FrontEnd/Loading/LoadingSlice'
import {fetchAsyncUserDetails} from '../../UserPages/accounts/Overview/OverviewSlice/UserDetailsSlice'
import PaymentSuccessPopup from '../../../Components/PaymentSuccessPopup'
import {ENV} from '../../../Utils/_helpers/EnvHelper'

import {useBuyCreditMutation} from '../../../../services/cellcast.v3'
import {BuyCreditParam} from '../../../../services/cellcast.v3.types'
import {GetCurrentData} from '../../../Utils/_helpers/GetCurrentData'
import {defaultRegion} from '../../../../_metronic/helpers'

const CARD_OPTIONS: any = {
  iconStyle: 'solid',
  hidePostalCode: true,

  style: {
    base: {
      color: '#303238',
      fontSize: '16px',
      fontFamily: 'sans-serif',
      fontSmoothing: 'antialiased',
      '::placeholder': {
        color: '#CFD7DF',
      },
    },
    invalid: {
      color: '#e5424d',
      ':focus': {
        color: '#303238',
      },
    },
  },
}
const CardPaymentPopup = ({
  show,
  handleClose,
  total,
  customData,
  couponId,
  restData,
  popupOpen = true,
  minCouponCredit = 0,
}: any) => {
  const currentUser = GetCurrentData()

  const dispatch = useDispatch()
  const [name, setName] = useState('')
  const [error, setError] = useState('')
  const [success, setSuccess] = useState(true)
  const [complete, setComplete] = useState(false)
  const [cardID, setCardID] = useState<any>('')
  const [successPopup, setsuccessPopup] = useState(false)
  const stripe: any = useStripe()
  const elements: any = useElements()
  const API_URL = ENV().REACT_APP_API_URL

  const cards = useSelector((state: any) => state?.productList?.cardList)

  const [buyCredit] = useBuyCreditMutation()

  const handleSubmit = async (e: any) => {
    e.preventDefault()
    if (currentUser?.region === defaultRegion) {
      handleSubmitDefaultRegion(e)
      return
    }
    try {
      dispatch(startLoadding())

      if (cardID) {
        // const reqBody =
        //   couponId !== ''
        //     ? {
        //       credit: customData,
        //       coupon: couponId,
        //       card: cardID,
        //     }
        //     : {
        //       credit: customData,
        //       card: cardID,
        //     }
        const param: BuyCreditParam = {
          credit: {
            amount: customData?.credits,
            type: customData?.type,
            cent_per_sms: customData?.priceperItems,
          },
          card: cardID,
        }
        const result = await buyCredit({
          action: 'buy_credit',
          data: param,
        }).unwrap()

        if (result) {
          dispatch(stopLoading())
          setsuccessPopup(true)
          dispatch(fetchAsyncUserDetails())
          setSuccess(true)
          handleClose()

          setCardID('')
        } else {
          dispatch(stopLoading())
          handleClose()
          toast.error('Payment fail')
          setCardID('')
        }
      } else {
        if (elements == null) {
          return
        }

        const cardElement = elements.getElement('card')

        const token = await stripe.createToken(cardElement, {name})
        const {error} = await stripe.createPaymentMethod({
          type: 'card',
          card: elements.getElement(CardElement),
          billing_details: {
            name,
          },
        })

        if (!error) {
          // const reqBody =
          // couponId !== ''
          //   ? {
          //       credit: customData,
          //       coupon: couponId,
          //       token: token?.token?.id,
          //     }
          //   : {
          //       credit: customData,
          //       token: token?.token?.id,
          //     }
          const param: BuyCreditParam = {
            credit: {
              amount: customData?.credits,
              type: customData?.type,
              cent_per_sms: customData?.priceperItems,
            },
            card: cardID,
            token: token?.token?.id,
          }
          const result = await buyCredit({
            action: 'buy_credit',
            data: param,
          }).unwrap()

          if (result) {
            dispatch(stopLoading())
            setsuccessPopup(true)
            dispatch(fetchAsyncUserDetails())
            setSuccess(true)
            dispatch(stopLoading())
            handleClose()
          } else {
            dispatch(stopLoading())
            handleClose()
            toast.error('Payment fail')
          }
        } else {
          console.log('errorerrorerror', error)
          toast.error(error?.message ?? 'Payment fail')
          dispatch(stopLoading())
        }
      }
    } catch (error) {
      console.log('errorerrorerror', error)
      toast.error('Stripe Failed to load!')
      dispatch(stopLoading())
    }
  }

  const handleSubmitDefaultRegion = async (e: any) => {
    e.preventDefault()
    try {
      dispatch(startLoadding())

      if (cardID) {
        let coupon = couponId
        if (minCouponCredit > 0 && customData?.credits < minCouponCredit) {
          coupon = ''
        }

        const reqBody =
          coupon !== ''
            ? {
                credit: customData,
                coupon: coupon,
                card: cardID,
              }
            : {
                credit: customData,
                card: cardID,
              }

        axios
          .post(`${API_URL}user/subscribe`, reqBody, {
            headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
          })
          .then((res: any) => {
            dispatch(stopLoading())
            setsuccessPopup(true)
            dispatch(fetchAsyncUserDetails())
            setSuccess(true)
            handleClose()

            setCardID('')
          })
          .catch((err: any) => {
            dispatch(stopLoading())
            handleClose()
            toast.error('Payment fail')
            setCardID('')
          })
      } else {
        if (elements == null) {
          return
        }

        const cardElement = elements.getElement('card')

        const token = await stripe.createToken(cardElement, {name})
        const {error} = await stripe.createPaymentMethod({
          type: 'card',
          card: elements.getElement(CardElement),
          billing_details: {
            name,
          },
        })

        if (!error) {
          const reqBody =
            couponId !== ''
              ? {
                  credit: customData,
                  coupon: couponId,
                  token: token?.token?.id,
                }
              : {
                  credit: customData,
                  token: token?.token?.id,
                }
          axios
            .post(`${API_URL}user/subscribe`, reqBody, {
              headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
            })
            .then((res: any) => {
              if (res?.status == 200) {
                dispatch(stopLoading())
                setsuccessPopup(true)
                dispatch(fetchAsyncUserDetails())
                setSuccess(true)
                dispatch(stopLoading())
                handleClose()
              }
            })
            .catch((err: any) => {
              dispatch(stopLoading())
              handleClose()
              toast.error('Payment fail')
            })
        } else {
          console.log('errorerrorerror', error)
          toast.error(error?.message ?? 'Payment fail')
          dispatch(stopLoading())
        }
      }
    } catch (error) {
      console.log('errorerrorerror', error)
      toast.error('Stripe Failed to load!')
      dispatch(stopLoading())
    }
  }
  useEffect(() => {
    dispatch(GetCardList())
  }, [])

  return (
    <>
      <PaymentSuccessPopup
        backdrop={true}
        restData={restData}
        show={successPopup && popupOpen}
        handleClose={() => setsuccessPopup(false)}
      />
      <Modal backdrop='static' className='payment_modal' show={show} onHide={handleClose}>
        <div className='modal-header text-center row'>
          <h1>Payment</h1>
        </div>
        <div className='modal-body'>
          <h2>
            Payable Amount:{' '}
            <span>${total}</span>
          </h2>
          {cards?.length > 0 && (
            <>
              <div className='row m-0 mt-5 mb-10  card_box'>
                {cards?.map((val: any, index: any) => (
                  <div
                    key={index}
                    className='form-check form-check-custom form-check-solid p-5 col-12 credit-card visa selectable '
                  >
                    <input
                      className='form-check-input'
                      type='radio'
                      // value={key.value}
                      id='flexRadioChecked'
                      name='role'
                      checked={val?.id == cardID}
                      onChange={() => {
                        setSuccess(true)
                        val?.id == cardID ? setCardID('') : setCardID(val?.id)

                        setComplete(true)
                      }}
                    />
                    <label className='form-check-label' htmlFor='kt_modal_update_role_option_0'>
                      <div className='text-black-600 visa'>
                        <span className='badge badge-light-success'>{val?.brand}</span>{' '}
                        <span>
                          {' '}
                          Expires {val?.exp_month}/{val?.exp_year}{' '}
                        </span>
                      </div>
                      <div className='fw-bolder card-label fs-4 mb-2'>XXXXXXX{val?.last4}</div>
                      <span className='fw-bolder fs-4 mb-1 credit-cardholder'>{val?.name}</span>
                    </label>
                  </div>
                ))}
              </div>
            </>
          )}
          {cards?.length !== 0 && (
            <button
              onClick={() => {
                setSuccess(false)
                setCardID('')
                setComplete(false)
              }}
              className='btn-sm btn-primary'
            >
              Add New Card
            </button>
          )}

          {(!success || cards?.length == 0) && (
            <fieldset className='FormGroup mt-10 border-0 p-0'>
              <div className='FormRow'>
                {/* <label className='fw-bolder text-dark fs-3'>Name</label> */}
                <input
                  onChange={(e: any) => {
                    let val = e.target.value

                    setName(val)
                    ;/^(?:[A-Za-z]+ ?){1,3}$/.test(val)
                      ? setError('')
                      : setError('Please enter valid Name')
                  }}
                  // onBlur={() => {}}
                  className='form-control form-control-lg form-control-solid w-100 my-3'
                  type='text'
                  placeholder='Card holder name'
                />
                <span className='text-danger'>{error}</span>
                <CardElement
                  onChange={(e) => {
                    setComplete(e?.complete)
                  }}
                  options={CARD_OPTIONS}
                />
              </div>
            </fieldset>
          )}
        </div>
        <div className='modal-footer border-top w-100'>
          <Button
            color='secondary'
            onClick={() => {
              handleClose()
            }}
            className='btn-light-primary'
          >
            Cancel
          </Button>
          <Button
            color='danger'
            disabled={!cardID ? !(complete && name !== '') : !cardID}
            onClick={handleSubmit}
          >
            <span className='px-8'>Pay</span>
          </Button>
        </div>
      </Modal>
    </>
  )
}

export default CardPaymentPopup
